import { useRef } from "react";
import styled from 'styled-components';
import ExperienceCard from './components/ExperienceCard';
import { ExperienceList } from './components/List';
import Textfit from 'react-textfit';
import { TypeAnimation } from 'react-type-animation';
import HeadingContainer from '@components/HeadingContainer';

function Experience({ sectionRefs }) {
  const scrollRef = useRef(null);
  const lines = [
    "In every line of code lies the potential to redefine the future.",
    "Design isn’t just aesthetics; it's the storyteller of functionality.",
    "Teamwork: where diverse beats harmonize into the symphony of success.",
    "Coding is the language that translates imagination into innovation.",
    "Design is the intersection where creativity meets usability.",
    "Teamwork is the fusion of minds shaping ideas into realities.",
    "Design speaks the unspoken, connecting emotion with functionality."
  ]

  return (
    <Container
      ref={(el) => {
        sectionRefs.current = { ...sectionRefs.current, Experience: el };
        scrollRef.current = el;
      }}
    >
      <HeadingContainer writeups="Experience" />
      <ExperienceContainer>
        <SpellContainer>
          <Textfit>
          <Spell> 
            <TypeAnimation sequence={lines} speed={20} wrapper = "div" /> 
          </Spell>
          </Textfit>
        </SpellContainer>
        <CardContainer>
          {ExperienceList.map((exp, idx) => {
            return (
              <ExperienceCard
                key={idx}
                title={exp.company}
                position={exp.position}
                companyImage={exp.companyImage}
                companyLink={exp.companyLink}
                description={exp.description}
                timeline={exp.timeline}
                stack={exp.skills}
              />
            );
          })}
        </CardContainer>
      </ExperienceContainer>
    </Container>
  )
}

export default Experience;

const Container = styled.section`
`;

const ExperienceContainer = styled.div`
  display: block;
  width: 100%;
`;

const SpellContainer = styled.div`
  box-sizing: border-box;
  justify-content: left;
  align-items: center;
  display: flex;
  padding-left: 2vw;
  padding-right: 2vw;
  display: grid;
  grid-template-rows: 1fr 0.8fr;
  margin-bottom: 1vw;
  

  @media (max-width: 450px) {
    height: 20vw;
  }

`;

const Spell = styled.span`
  display: inline-block;
  font-family: "Neue Montreal";
  font-weight: 500;
  font-size: 3vw;
  font-weight: 300;
  line-height: 1.2;
  background-color: #504f4f;

  color: #ffffffb4;

  &.pink {
    display: flex;
  }

  @media (max-width: 450px) {
    font-size: 3vw;
  }
`;

const CardContainer = styled.div`
  padding: 0 10%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 5vh;
`
